import axios from 'axios';
import { LOGIN_CONST } from '../constant/page-constants';
import { getCookieCustom, clearAuthSession } from '../utils/StorageUItils';

axios.interceptors.request.use((config) => {
    if (config.authRequired) {
        const accessToken = getCookieCustom(LOGIN_CONST.ACCESS_TOKEN);

        if (accessToken) {
            config.headers['Authorization'] = `${accessToken}`;
        } else {
            clearAuthSession();
            window.location = "/";
        }
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error && error.response && (401 === error.response.status)) {
        clearAuthSession();
        window.location = "/";
    }

    return Promise.reject(error);
});
